module.exports = __webpack_public_path__ + "static/media/videocreate.e0a2d3f1.svg";